<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { ddStore } from "@common/ddStore";

let vmsCustomAttributeGroupCredentialEditConfig = {
    cId: "vmsCustomAttributeGroupCredentialEdit",
    cType: "vmsCustomAttributeGroupCredentialEdit",
    cTitle: "Edit Credential",
    cTemplate: `<div :id="wrapperID" class="vmsCustomAttributeGroupCredentialEdit-wrapper" :class="{'is-from-popup': isFromPopup}">
                    <div>
                        <div class="vmsCustomAttributeGroupCredentialEdit-title">
                            {{attrGroupId ? 'Edit' : 'Add New'}} Credential
                        </div>
                        <div class="vmsCustomAttributeGroupCredentialEdit-subTitle">
                            <span>Please enter the following information about the {{attrGroupId ? '' : 'new'}} credential</span>
                        </div>
                        <div class="vmsCustomAttributeGroupCredentialEdit-fieldsWrapper">
                            <control
                                name="CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_NAME"
                                class="vmsCustomAttributeGroupCredentialEdit-field"
                                label="Credential Name:"
                                @blur="focusoutForNameField"
                            ></control>
                            <control
                                name="CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_LABEL"
                                class="vmsCustomAttributeGroupCredentialEdit-field"
                                label="Credential Label:"
                                @blur="focusoutForLabelField"
                            ></control>
                            <control
                                name="CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_DESC"
                                class="vmsCustomAttributeGroupCredentialEdit-field"
                                label="Description:"
                            ></control>
                            <control
                                name="CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_HEADER_NAME"
                                class="vmsCustomAttributeGroupCredentialEdit-field"
                                label="Header Name:"
                            ></control>
                            <control
                                name="CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_HEADER_LABEL"
                                class="vmsCustomAttributeGroupCredentialEdit-field"
                                label="Header Label:"
                            ></control>
                            <div class="vmsCustomAttributeGroupCredentialEdit-statusLabels">
                                <control
                                    name="CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_LABEL_OK"
                                    class="labelOK"
                                    label="OK Status Value Label:"
                                ></control>
                                <control
                                    name="CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_LABEL_NOT_OK"
                                    class="labelNotOK"
                                    label="Not OK Status Value Label:"
                                ></control>
                            </div>
                            <div style="margin-top: 20px;">
                                <span>
                                    No components have been created for this credential.
                                    Please create the components of this credential and then return to create the rule that defines OK status for this credential.
                                </span>
                            </div>
                            <div v-if="withVisibility()" class="vmsCustomAttributeGroupCredentialEdit-visibilityWrapper">
                                <span>Visibility:</span>
                                <control
                                    name="CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_VISIBILITY_RADIO"
                                    class="vmsCustomAttributeGroupCredentialEdit-visibility"
                                    :items="visibilityModes"
                                    @update:value="changeVisibilityMode"
                                ></control>
                            </div>
                            <div v-if="isVisibleApplyChangesCtx">
                                <control name="CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_APPLY_CTX_CHECKBOX" :disabled="getVisibilityMode() === 1"></control>
                            </div>
                            <div v-if="withPermissions()" class="vmsCustomAttributeGroupCredentialEdit-permissionsWrapper">
                                <a class="vmsCustomAttributeGroupCredentialEdit-permissions" @click="openPermissions">Set Permissions and Sharing</a>
                            </div>
                        </div>
                    </div>
                    <div class="vmsCustomAttributeGroupCredentialEdit-buttons">
                        <div class="vmsCustomAttributeGroupCredentialEdit-button"><control name="CUSTOM_ATTRIBUTE_MANAGER_GROUP_CREDENTIAL_EDIT_OK_BUTTON"></control></div>
                        <div class="vmsCustomAttributeGroupCredentialEdit-button"><control name="CUSTOM_ATTRIBUTE_MANAGER_GROUP_CREDENTIAL_EDIT_CANCEL_BUTTON"></control></div>
                    </div>
               </div>
               `,
    controls: [
        {
            name: 'CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_NAME',
            type: 'string',
            enableHtml: false,
            hideMessage: true,
            display: true,
            fields: { text: 'text', value: 'value' },
            htmlAttributes: { maxlength: 180 },
            ref: 'vmsCustomAttributeGroupCredentialEditName'
        },
        {
            name: 'CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_LABEL',
            type: 'text',
            hideMessage: true,
            display: true,
            fields: { text: 'text', value: 'value' },
            htmlAttributes: { maxlength: 180 },
            ref: 'vmsCustomAttributeGroupCredentialEditLabel'
        },
        {
            name: 'CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_DESC',
            type: 'text',
            hideMessage: true,
            display: true,
            fields: { text: 'text', value: 'value' },
            htmlAttributes: { maxlength: 180 },
            ref: 'vmsCustomAttributeGroupCredentialEditDesc'
        },
        {
            name: 'CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_HEADER_NAME',
            type: 'string',
            hideMessage: true,
            display: true,
            fields: { text: 'text', value: 'value' },
            htmlAttributes: { maxlength: 180 },
            ref: 'vmsCustomAttributeGroupCredentialEditHeaderName'
        },
        {
            name: 'CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_HEADER_LABEL',
            type: 'text',
            hideMessage: true,
            display: true,
            fields: { text: 'text', value: 'value' },
            htmlAttributes: { maxlength: 180 },
            ref: 'vmsCustomAttributeGroupCredentialEditHeaderLabel'
        },
        {
            name: 'CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_LABEL_OK',
            type: 'string',
            hideMessage: true,
            display: true,
            fields: { text: 'text', value: 'value' },
            htmlAttributes: { maxlength: 180 },
            ref: 'vmsCustomAttributeGroupCredentialEditLabelOK'
        },
        {
            name: 'CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_LABEL_NOT_OK',
            type: 'string',
            hideMessage: true,
            display: true,
            fields: { text: 'text', value: 'value' },
            htmlAttributes: { maxlength: 180 },
            ref: 'vmsCustomAttributeGroupCredentialEditLabelNotOK'
        },
        {
            name: 'CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_VISIBILITY_RADIO',
            type: 'radio_button_list',
            hideMessage: true,
            fields: { text: 'text', value: 'value' },
        },
        {
            name: 'CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_APPLY_CTX_CHECKBOX',
            type: 'checkbox',
            label: 'DD.CUSTOM_ATTRIBUTE.CUSTOMATTRIBUTEEDITOR_GROUP_CHANGE_APPLY_CTX'
        },
        // bottom buttons
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_GROUP_CREDENTIAL_EDIT_OK_BUTTON',
            type: 'button',
            label: 'OK',
            onclick: 'save',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_GROUP_CREDENTIAL_EDIT_CANCEL_BUTTON',
            type: 'button',
            label: 'Cancel',
            onclick: 'close',
        },
    ]
};

let vmsCustomAttributeGroupCredentialEditCmp = {
    name: 'vmsCustomAttributeGroupCredentialEdit',
    preInitControls: true,
    props: {
        isFromPopup: {
            default: false
        },
        attrGroupId: {
            type: Number,
            default: null
        },
        saveCallback: {
            type: Function,
            default: null
        },
    },
    data() {
        return {
            currentVisibilityMode: -1,
            visibilityModes: [],
            isVisibleApplyChangesCtx: false,
            clientPermissions: []
        };
    },
    computed: {
        wrapperID() {
            return this.cId + 'Wrapper';
        },
    },
    components: {
        labelWrapper: defineAsyncComponent(() => import('@common/control/labelWrapper'))
    },
    methods: {
        withVisibility() {
            return this.currentVisibilityMode !== -1 && this.visibilityModes.length > 0;
        },
        withPermissions() {
            return this.clientPermissions.length > 0;
        },
        getVisibilityMode() {
            if (this.attrGroupId && typeof this.controls['CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_VISIBILITY_RADIO'] !== 'undefined') {
                return this.controls['CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_VISIBILITY_RADIO'].value;
            }
            return null;
        },
        changeVisibilityMode() {
            if (
                this.isVisibleApplyChangesCtx
                && typeof this.controls['CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_APPLY_CTX_CHECKBOX'] !== 'undefined'
                && this.getVisibilityMode() === 1
            ) {
                this.controls['CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_APPLY_CTX_CHECKBOX'].value = 0;
            }
        },
        async onLoad() {
            this.$emit('update:vmsCustomAttributeGroupCredentialEditLoaded', true);
            if (typeof this.attrGroupId !== 'number' || !this.attrGroupId) {
                this.attrGroupId = null;
            }
            if (this.attrGroupId) {
                library.showLoadingIndicator(this.wrapperID);
                let editorParams = await this.getCustomAttributeGroupEditParams();
                if (typeof editorParams === 'object') {
                    if (typeof editorParams.isVisibleApplyChangesCtx === 'boolean') {
                        this.isVisibleApplyChangesCtx = editorParams.isVisibleApplyChangesCtx;
                    }
                    if (typeof editorParams.accessModes === 'object') {
                        let tmpVisibilityModes = [];
                        editorParams.accessModes.forEach((item) => {
                            tmpVisibilityModes.push({
                                text: item.modeName,
                                value: item.modeID
                            });
                        });
                        this.visibilityModes = library.cloneObj(tmpVisibilityModes);
                    }
                }
                let groupInfo = await this.getCustomAttributeGroupInfo(this.attrGroupId);
                if (typeof groupInfo === 'object') {
                    this.currentVisibilityMode = groupInfo['ACCESS_MODE_SELECTED'];
                    if (typeof this.refs['vmsCustomAttributeGroupCredentialEditName'] !== 'undefined') {
                        this.refs['vmsCustomAttributeGroupCredentialEditName'].value = groupInfo['CUSTOM_ATTRIBUTE_GROUP_NAME'];
                    }
                    if (typeof this.refs['vmsCustomAttributeGroupCredentialEditLabel'] !== 'undefined') {
                        this.refs['vmsCustomAttributeGroupCredentialEditLabel'].value = groupInfo['CUSTOM_ATTRIBUTE_GROUP_LABEL'];
                    }
                    if (typeof this.refs['vmsCustomAttributeGroupCredentialEditDesc'] !== 'undefined') {
                        this.refs['vmsCustomAttributeGroupCredentialEditDesc'].value = groupInfo['CUSTOM_ATTRIBUTE_GROUP_DESC'];
                    }
                    if (typeof this.refs['vmsCustomAttributeGroupCredentialEditHeaderName'] !== 'undefined') {
                        this.refs['vmsCustomAttributeGroupCredentialEditHeaderName'].value = groupInfo['CUSTOM_ATTRIBUTE_GROUP_HNAME'];
                    }
                    if (typeof this.refs['vmsCustomAttributeGroupCredentialEditHeaderLabel'] !== 'undefined') {
                        this.refs['vmsCustomAttributeGroupCredentialEditHeaderLabel'].value = groupInfo['CUSTOM_ATTRIBUTE_GROUP_HLABEL'];
                    }
                    if (typeof this.refs['vmsCustomAttributeGroupCredentialEditLabelOK'] !== 'undefined') {
                        this.refs['vmsCustomAttributeGroupCredentialEditLabelOK'].value = groupInfo['CAG_LABEL_OK'];
                    }
                    if (typeof this.refs['vmsCustomAttributeGroupCredentialEditLabelNotOK'] !== 'undefined') {
                        this.refs['vmsCustomAttributeGroupCredentialEditLabelNotOK'].value = groupInfo['CAG_LABEL_NOT_OK'];
                    }
                    if (typeof this.controls['CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_VISIBILITY_RADIO'] !== 'undefined') {
                        this.controls['CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_VISIBILITY_RADIO'].value = groupInfo['ACCESS_MODE_SELECTED'];
                    }
                    if (typeof groupInfo['PERMISSIONS'] === 'object') {
                        this.clientPermissions = library.cloneObj(groupInfo['PERMISSIONS']);
                    }
                }
                library.hideLoadingIndicator(this.wrapperID);
            }
        },
        async focusoutForNameField() {
            if (
                this.refs['vmsCustomAttributeGroupCredentialEditName'].value
                && typeof this.refs['vmsCustomAttributeGroupCredentialEditHeaderName'] !== 'undefined'
                && !this.refs['vmsCustomAttributeGroupCredentialEditHeaderName'].value
            ) {
                this.refs['vmsCustomAttributeGroupCredentialEditHeaderName'].value = this.refs['vmsCustomAttributeGroupCredentialEditName'].value + ' Header';
            }
        },
        async focusoutForLabelField() {
            if (
                this.refs['vmsCustomAttributeGroupCredentialEditLabel'].value
                && typeof this.refs['vmsCustomAttributeGroupCredentialEditHeaderLabel'] !== 'undefined'
                && !this.refs['vmsCustomAttributeGroupCredentialEditHeaderLabel'].value
            ) {
                this.refs['vmsCustomAttributeGroupCredentialEditHeaderLabel'].value = this.refs['vmsCustomAttributeGroupCredentialEditLabel'].value;
            }
        },
        async openPermissions() {
            let clientPermissions = library.cloneObj(this.clientPermissions);
            let changeCallback = async (changedPermissions) => {
                if (typeof changedPermissions === 'object') {
                    this.clientPermissions = library.cloneObj(changedPermissions);
                }
            };

            actionStore.openChangePermissions(clientPermissions, changeCallback);
        },
        async save() {
            let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
            let message = null;
            let attrGroupId = this.attrGroupId;
            let groupName = this.refs['vmsCustomAttributeGroupCredentialEditName'].value.trim();
            let groupInfo = {
                CUSTOM_ATTRIBUTE_GROUP_LABEL: this.refs['vmsCustomAttributeGroupCredentialEditLabel'].value,
                CUSTOM_ATTRIBUTE_GROUP_DESC: this.refs['vmsCustomAttributeGroupCredentialEditDesc'].value,
                CUSTOM_ATTRIBUTE_GROUP_HNAME: this.refs['vmsCustomAttributeGroupCredentialEditHeaderName'].value.trim(),
                CUSTOM_ATTRIBUTE_GROUP_HLABEL: this.refs['vmsCustomAttributeGroupCredentialEditHeaderLabel'].value,
                CAG_LABEL_OK: this.refs['vmsCustomAttributeGroupCredentialEditLabelOK'].value,
                CAG_LABEL_NOT_OK: this.refs['vmsCustomAttributeGroupCredentialEditLabelNotOK'].value
            };
            if (groupName.length === 0) {
                let fieldName = 'Credential Name';
                message = await ddStore.getAlias('CUSTOM_ATTRIBUTE', 'CUSTOMATTRIBUTEMANAGER_ERROR_EMPTY', fieldName);
                library.showDialog(message, false, false, {
                    title: title, name: 'vmsCustomAttributeGroupCredentialEditWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                });
                return;
            }
            if (groupInfo.CUSTOM_ATTRIBUTE_GROUP_HNAME.length === 0) {
                let fieldName = 'Header Label';
                message = await ddStore.getAlias('CUSTOM_ATTRIBUTE', 'CUSTOMATTRIBUTEMANAGER_ERROR_EMPTY', fieldName);
                library.showDialog(message, false, false, {
                    title: title, name: 'vmsCustomAttributeGroupCredentialEditWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                });
                return;
            }
            if (attrGroupId) {
                let visibilityMode = null;
                let isApplyChangesCtx = null;
                if (this.withVisibility() && typeof this.controls['CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_VISIBILITY_RADIO'] !== 'undefined') {
                    visibilityMode = this.controls['CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_VISIBILITY_RADIO'].value;
                }
                if (this.isVisibleApplyChangesCtx && typeof this.controls['CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_APPLY_CTX_CHECKBOX'] !== 'undefined') {
                    isApplyChangesCtx = this.controls['CUSTOM_ATTRIBUTE_GROUP_CREDENTIAL_EDIT_APPLY_CTX_CHECKBOX'].value;
                }
                library.showLoadingIndicator(this.wrapperID);
                this.sDs.post('ec_updateCustomAttributeGroupInfo', attrGroupId, groupName, visibilityMode, isApplyChangesCtx, groupInfo).then((response) => {
                    library.hideLoadingIndicator(this.wrapperID);
                    if (response && response.status === 'success') {
                        if (typeof this.saveCallback === 'function') {
                            this.saveCallback();
                        }
                        this.close();
                    } else if (typeof response.error === 'object' && response.error.length) {
                        library.showDialog(response.error[0], false, false, {
                            title: title, name: 'vmsCustomAttributeGroupCredentialEditWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                        });
                    }
                });
            } else {
                library.showLoadingIndicator(this.wrapperID);
                this.sDs.post('ec_createCustomAttributeGroup', 15, groupName, groupInfo).then((response) => {
                    library.hideLoadingIndicator(this.wrapperID);
                    if (response && response.status === 'success') {
                        if (typeof this.saveCallback === 'function') {
                            this.saveCallback();
                        }
                        this.close();
                    } else if (typeof response.error === 'object' && response.error.length) {
                        library.showDialog(response.error[0], false, false, {
                            title: title, name: 'vmsCustomAttributeGroupCredentialEditWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                        });
                    }
                });
            }
        },
        close() {
            if (/openvmsCustomAttributeGroupCredentialEdit/g.test(window.name)) {
                window.close();
            } else if (
                this.$parent
                && this.$parent.$parent
                && this.$parent.$parent.$parent
                && typeof this.$parent.$parent.$parent.componentDialogs === 'object'
                && this.$parent.$parent.$parent.componentDialogs.length
            ) {
                this.$parent.$parent.$parent.componentDialogs.find((component) => component.name === 'openvmsCustomAttributeGroupCredentialEdit')?.cancelButton?.click();
            }
        },
        // sDs
        async getCustomAttributeGroupEditParams() {
            let response = await this.sDs.post('ec_getCustomAttributeGroupEditParams');
            return response && response.status === 'success' && typeof response.data !== 'undefined' ? response.data : null;
        },
        async getCustomAttributeGroupInfo(attrGroupId) {
            let response = await this.sDs.post('ec_getCustomAttributeGroupInfo', attrGroupId);
            return response && response.status === 'success' && typeof response.data !== 'undefined' ? response.data : null;
        },
    }
};

componentStore.initComponent(vmsCustomAttributeGroupCredentialEditCmp, vmsCustomAttributeGroupCredentialEditConfig);
export { vmsCustomAttributeGroupCredentialEditConfig, vmsCustomAttributeGroupCredentialEditCmp };
export default vmsCustomAttributeGroupCredentialEditCmp;
</script>

<style>
#dialog_container_openvmsCustomAttributeGroupCredentialEdit, #dialog_container_openvmsCustomAttributeGroupCredentialEdit > div {
    min-height: 200px;
}
</style>
<style scoped>
:deep(.vmsCustomAttributeGroupCredentialEdit-title) {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: #41362f;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-subTitle) {
    margin-top: 20px;
    text-align: center;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-Wrapper) {
    display: flex;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-mainWrapper) {
    margin-top: 20px;
    width: 100%;
    display: inline-block;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-wrapper) {
    width: 100%;
    min-height: 200px;
    background-color: #fff;
    padding: 20px;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-fieldsWrapper) {
    margin-top: 20px;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-field) {
    margin-bottom: 10px;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-statusLabels) {
    display: flex;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-statusLabels .labelOK) {
    width: calc(50% - 10px);
    margin-right: 10px;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-statusLabels .labelNotOK) {
    width: calc(50% - 10px);
    margin-left: 10px;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-visibilityWrapper) {
    margin-top: 20px;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-visibility) {
    top: -10px;
    position: relative;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-permissionsWrapper) {
    margin-top: 10px;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-permissions) {
    text-decoration: none;
    cursor: pointer;
}
:deep(.is-from-popup) {
    width: 100%;
    height: 100%;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-buttons) {
    text-align: center;
    margin-top: 20px;
    clear: both;
}
:deep(.vmsCustomAttributeGroupCredentialEdit-button) {
    display: inline-block;
    margin-left: 20px;
    width: 90px;
}
</style>
